import { cn } from '@v2/shared/lib/utils';

type Props = {
  name: string;
  className?: string;
};

/**
 * Which platform collected this review, on the review.
 *
 * One platform collects every review on this page today. It is still stated per card
 * rather than once in the footer, because that is what a shopper checking whether these
 * are real reviews is looking for, and because it is a property of the review — the day
 * SmartCustomer starts relaying another platform's reviews to us, the label is where it
 * belongs already.
 */
export default function SourceLabel({ name, className }: Props) {
  return <span className={cn('text-slate-500', className)}>via {name}</span>;
}
